// counter.ts
import { createAction, props, createReducer, on } from '@ngrx/store';
import { ElementsVisibilityState } from '../api/plyca-dtos';


export const SET_ELEMVISIBILITY = createAction('SET_ELEMVISIBILITY', props<{ visibilityState: ElementsVisibilityState }>());


const initialState = new ElementsVisibilityState();

const _elemVisibilityStateReducer = createReducer(
  initialState,
  on(SET_ELEMVISIBILITY, (state, { visibilityState }) => visibilityState)
);

export function elemVisibilityStateReducer(state, action) {
  return _elemVisibilityStateReducer(state, action);
}
